<script lang="ts">
	import MetaHead from '$lib/components/MetaHead.svelte';

	let { data } = $props();
	const lawLink = 'https://www.legifrance.gouv.fr/loda/article_lc/LEGIARTI000049577522';
</script>

<MetaHead {data} />

<section class="mx-auto mt-24 max-w-4xl rounded-md bg-foreground/10 p-6 leading-relaxed shadow-md">
	<h1 class="mb-6 text-3xl font-bold">Mentions Légales</h1>
	<p class="mb-8 text-sm text-gray-500">Dernière mise à jour : 08 février 2026</p>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">1. Édition du site</h2>
		<p>
			En vertu de l'<a
				href={lawLink}
				target="_blank"
				rel="noreferrer"
				class="text-blue-600 hover:underline">article 6 de la loi n° 2004-575 du 21 juin 2004</a
			>
			pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site internet
			<strong>https://www.juslin.dev/</strong> l'identité des différents intervenants dans le cadre de
			sa réalisation et de son suivi :
		</p>
		<ul class="mt-2 list-none space-y-1">
			<li><strong>Propriétaire :</strong> Juslin Komenan</li>
			<li>
				<strong>Contact :</strong> Via les réseaux sociaux ou le formulaire de contact du site.
			</li>
			<li><strong>Directeur de la publication :</strong> Juslin Komenan</li>
		</ul>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">2. Hébergement</h2>
		<p>
			Le site est hébergé par <strong>Vercel Inc.</strong><br />
			Adresse : 440 N Barranca Ave #4133, Covina, CA 91723, États-Unis.<br />
			Site web :
			<a href="https://vercel.com/" class="text-blue-600 hover:underline">https://vercel.com/</a>
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">3. Propriété intellectuelle et contrefaçons</h2>
		<p>
			Juslin Komenan est propriétaire des droits de propriété intellectuelle ou détient les droits
			d’usage sur tous les éléments accessibles sur le site internet, notamment les textes, images,
			graphismes, logos, vidéos, architecture, icônes et sons.
		</p>
		<p class="mt-2">
			Toute reproduction, représentation, modification, publication, adaptation de tout ou partie
			des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf
			autorisation écrite préalable.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">4. Limitations de responsabilité</h2>
		<p>
			Juslin Komenan ne pourra être tenu pour responsable des dommages directs et indirects causés
			au matériel de l’utilisateur, lors de l’accès au site <strong>https://www.juslin.dev/</strong
			>.
		</p>
		<p class="mt-2">
			Juslin Komenan décline toute responsabilité quant à l’utilisation qui pourrait être faite des
			informations et contenus présents sur <strong>https://www.juslin.dev/</strong>.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">5. CNIL et gestion des données personnelles</h2>
		<p>
			Conformément aux dispositions de la loi 78-17 du 6 janvier 1978 modifiée, l’utilisateur du
			site <strong>https://www.juslin.dev/</strong> dispose d’un droit d’accès, de modification et
			de suppression des informations collectées. Pour plus de détails, consultez notre
			<a href="/privacy-policy" rel="noreferrer" class="text-blue-600 hover:underline"
				>Politique de Confidentialité</a
			>.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">6. Liens hypertextes et cookies</h2>
		<p>
			Le site <strong>https://www.juslin.dev/</strong> contient des liens hypertextes vers d’autres sites
			et dégage toute responsabilité à propos de ces liens externes. La navigation sur le site est susceptible
			de provoquer l’installation de cookie(s) sur l’ordinateur de l’utilisateur à des fins de statistiques
			anonymes.
		</p>
	</section>

	<footer class="mt-12 border-t border-gray-200 pt-6">
		<a href="/" class="text-blue-600 hover:underline">← Retour à l'accueil</a>
	</footer>
</section>
